export const EN_REWARDS_CONFIGURATION_STRINGS = {
  // Entity-level
  REWARDS_CONFIGURATION:
    '{count, plural, one {Rewards Configuration} other {Rewards Configurations}}',
  REWARDS_CONFIGURATION_MENU: 'Rewards Configuration',
  REWARDS_TENANT_CONFIGURATION: 'Tenant Configuration',
  REWARDS_ACHIEVEMENTS:
    '{count, plural, one {Achievement} other {Achievements}}',
  REWARDS_DEFINITIONS: '{count, plural, one {Reward} other {Rewards}}',

  REWARDS_ACHIEVEMENT_LABEL: 'Achievement',
  REWARDS_ACHIEVEMENT_HINT:
    'Achievements created for the tenant are displayed in the below list.',
  REWARDS_ACHIEVEMENT_NAME_LABEL: 'Name',
  REWARDS_ACHIEVEMENT_DESCRIPTION_LABEL: 'Description',
  REWARDS_ACHIEVEMENT_IMAGE_LABEL: 'Badge image',
  REWARDS_ACHIEVEMENT_IMAGE_HINT:
    'The image or icon for the achievement badge that will be displayed to the user.',

  REWARDS_REWARD_LABEL: 'Reward',
  REWARDS_REWARD_NAME_LABEL: 'Name',
  REWARDS_REWARD_DESCRIPTION_LABEL: 'Description',
  REWARDS_REWARD_CATEGORY_LABEL: 'Category',
  REWARDS_CATEGORY_PROGRAM_LABEL: 'Program',
  REWARDS_CATEGORY_CHALLENGE_LABEL: 'Challenge',
  REWARDS_CATEGORY_ACTIVITY_LABEL: 'Activity',
  REWARDS_CATEGORY_WEEKLY_STREAK_LABEL: 'Weekly streak',
  REWARDS_REWARD_AMOUNT_LABEL: 'Amount',
  REWARDS_REWARD_AMOUNT_HINT:
    'How many points the user will earn each time the reward is awarded.',
  REWARDS_REWARD_ACCOUNT_LABEL: 'Rewards account',
  REWARDS_REWARD_ACCOUNT_HINT:
    'Identifier of the rewards account in which the amount will be added to the balance.',
  REWARDS_REWARD_ACHIEVEMENTS_LABEL: 'Achievements',
  REWARDS_REWARD_ACHIEVEMENTS_HINT:
    'Achievements members earn along with this reward. Only published achievements are listed.',
  REWARDS_REWARD_ACHIEVEMENTS_ADD_LABEL: 'Add achievement',
  REWARDS_REWARD_ACHIEVEMENTS_ITEM_LABEL: 'Achievement',
  REWARDS_REWARD_AWARD_LIMIT_LABEL: 'Award limit',
  REWARDS_REWARD_AWARD_LIMIT_HINT:
    'How many times a member can earn this reward. 0 means unlimited.',
  REWARDS_REWARD_START_AT_LABEL: 'Start date',
  REWARDS_REWARD_START_AT_HINT:
    "The date the reward starts being awardable. If you leave this blank, the reward will be available as soon as it's published.",
  REWARDS_REWARD_END_AT_LABEL: 'End date',
  REWARDS_REWARD_END_AT_HINT:
    'The date the reward stops being awardable. If you leave this blank, the reward will be available until it is unpublished or archived.',

  REWARDS_REWARD_CRITERIA: 'Criteria',
  REWARDS_REWARD_CRITERIA_KIND: 'Targets required',
  REWARDS_REWARD_CRITERIA_KIND_SINGLE: 'A single target',
  REWARDS_REWARD_CRITERIA_KIND_ALL_OF: 'All of the targets',
  REWARDS_REWARD_CRITERIA_KIND_ANY_OF: 'Any of the targets',
  REWARDS_REWARD_CRITERIA_TARGET_CONFIG_IDS: 'Target configuration IDs',
  REWARDS_REWARD_CRITERIA_TARGET_CONFIG_IDS_HINT:
    'IDs of the Metric Tracker target configurations a member must meet.',
  REWARDS_REWARD_CRITERIA_TARGET_CONFIG_IDS_ADD: 'Add target configuration',
  REWARDS_REWARD_CRITERIA_TARGET_CONFIG_ID: 'Target configuration ID',
  REWARDS_REWARD_CRITERIA_ASSOCIATED_CAMPAIGN: 'Campaign',

  // List table
  REWARDS_CONFIGURATION_NAME_COLUMN: 'Name',
  REWARDS_CONFIGURATION_STATUS_COLUMN: 'Status',
  REWARDS_CONFIGURATION_LAST_UPDATED_COLUMN: 'Last updated',
  REWARDS_CAMPAIGN_ID_COLUMN: 'Campaign ID',

  // Reset
  REWARDS_CONFIGURATION_RESET_LABEL: 'Reset to default',
  REWARDS_CONFIGURATION_RESET_LOADING_MESSAGE:
    'Resetting rewards configuration…',
  REWARDS_CONFIGURATION_RESET_SUCCESS_MESSAGE:
    'Rewards configuration reset to its original content.',
  REWARDS_CONFIGURATION_RESET_CONFIRMATION_TITLE:
    'Reset rewards configuration?',
  REWARDS_CONFIGURATION_RESET_CONFIRMATION_MESSAGE:
    'This restores the copy this tenant was set up with and discards every edit since. It cannot be undone.',
  REWARDS_CONFIGURATION_RESET_CONFIRMATION_LABEL: 'Reset',

  REWARDS_CONFIGURATION_CONTENT: 'Tenant Configuration',

  // Achievement categories
  REWARDS_ACHIEVEMENT_CONFIG: 'Achievement categories',
  REWARDS_ACHIEVEMENT_CONFIG_HINT:
    'To change the display order of achievements, drag the categories into the order you want.',
  REWARDS_ACHIEVEMENT_CONFIG_ITEM: 'Achievement category',
  REWARDS_CATEGORY: 'Category',
  REWARDS_CATEGORY_TITLE: 'Category Title',

  // Category unit
  REWARDS_CATEGORY_UNIT: 'Unit label',
  REWARDS_CATEGORY_UNIT_SINGULAR: 'Singular',
  REWARDS_CATEGORY_UNIT_PLURAL: 'Plural',

  // Category description
  REWARDS_CATEGORY_DESCRIPTION: 'Category description',
  REWARDS_CATEGORY_DESCRIPTION_PREFIX: 'Prefix',
  REWARDS_CATEGORY_DESCRIPTION_SUFFIX: 'Suffix',
  REWARDS_CATEGORY_DESCRIPTION_TEXT: 'Description',
  REWARDS_CATEGORY_DESCRIPTION_TEXT_EARNED: 'Description once earned',

  // Category empty state
  REWARDS_CATEGORY_EMPTY_STATE: 'Empty state',
  REWARDS_CATEGORY_EMPTY_STATE_TITLE: 'Empty state heading',
  REWARDS_CATEGORY_EMPTY_STATE_DESCRIPTION: 'Empty state description',
  REWARDS_CATEGORY_EMPTY_STATE_CTA: 'Empty state button label',
  REWARDS_CATEGORY_EMPTY_STATE_URL: 'Empty state button link',

  // Achievement copy
  REWARDS_ACHIEVEMENT_DESCRIPTION: 'Achievement description',
  REWARDS_ACHIEVEMENT_DESCRIPTION_IN_PROGRESS: 'While in progress',
  REWARDS_ACHIEVEMENT_DESCRIPTION_EARNED: 'Once earned',
  REWARDS_ACHIEVEMENT_PLACEHOLDERS_BANNER_TITLE: 'Placeholders',
  REWARDS_ACHIEVEMENT_PLACEHOLDERS_BANNER_DESCRIPTION:
    'PLACEHOLDER_ACHIEVEMENT_NAME is the name of the program or challenge the achievement belongs to. PLACEHOLDER_EVENT_NUMBER is an integer representing the number of times the event/action must be executed. PLACEHOLDER_DISPLAY_UNIT is the unit of that event/action (for example "activities" or "days"), in singular or plural to match the number.',

  // Celebration
  REWARDS_ACHIEVEMENT_CELEBRATION: 'Celebration',
  REWARDS_ACHIEVEMENT_CELEBRATION_TITLE: 'Celebration Title',
  REWARDS_ACHIEVEMENT_CELEBRATION_SUBTITLE: 'Celebration Subtitle',

  REWARDS_CTA_DESTINATION_URL: 'Call to action link',
};
